export const PAYMENT_LOG_STEPS = {
  SWITCH_FORM_STARTED: 'SWITCH_FORM_STARTED',
  TOKENIZATION_STARTED: 'TOKENIZATION_STARTED',
  SWITCH_FORM_FAILED: 'SWITCH_FORM_FAILED',
  SWITCH_FORM_COMPLETE: 'SWITCH_FORM_COMPLETE',
  AUTHORISING_PAYMENT_METHOD: 'AUTHORISING_PAYMENT_METHOD',
  AUTHORISING_PAYMENT_METHOD_FAILED: 'AUTHORISING_PAYMENT_METHOD_FAILED',
  PAYMENT_AUTHORISED: 'PAYMENT_AUTHORISED',
  SUBSCRIPTION_FULFILLMENT_STARTED: 'SUBSCRIPTION_FULFILLMENT_STARTED',
  SUBSCRIPTION_FULFILLMENT_POLL_RETRY: 'SUBSCRIPTION_FULFILLMENT_POLL_RETRY',
  SUBSCRIPTION_FULFILLMENT_POLL_TIMEOUT: 'SUBSCRIPTION_FULFILLMENT_POLL_TIMEOUT',
  SUBSCRIPTION_FULFILLMENT_FAILED: 'SUBSCRIPTION_FULFILLMENT_FAILED',
  SUBSCRIPTION_FULFILLED: 'SUBSCRIPTION_FULFILLED',
  THANKS_PAGE_SHOWN: 'THANKS_PAGE_SHOWN',
  DUPLICATE_PAYMENT_GUARD_SET: 'DUPLICATE_PAYMENT_GUARD_SET',
  DUPLICATE_PAYMENT_BLOCKED: 'DUPLICATE_PAYMENT_BLOCKED',
  DUPLICATE_PAYMENT_GUARD_RESET_TOKENISATION_FAILURE: 'DUPLICATE_PAYMENT_GUARD_RESET_TOKENISATION_FAILURE',
  DUPLICATE_PAYMENT_GUARD_RESET_BILLING_FAILURE: 'DUPLICATE_PAYMENT_GUARD_RESET_BILLING_FAILURE',
  DUPLICATE_PAYMENT_GUARD_BLOCKED_AT_PURCHASE: 'DUPLICATE_PAYMENT_GUARD_BLOCKED_AT_PURCHASE',
  PAYMENT_METHOD_TOKENIZATION_FAILED: 'PAYMENT_METHOD_TOKENIZATION_FAILED',
};
